import { isPlatformBrowser } from "@angular/common";
import {
  AfterViewInit,
  Component,
  inject,
  Injector,
  PLATFORM_ID,
  ChangeDetectionStrategy,
} from "@angular/core";
import { BsModalService } from "ngx-bootstrap/modal";
import { InitModalComponent } from "./shared/init-modal/init-modal.component";
import { HeaderComponent } from "./shared/header/header.component";
import { FooterComponent } from "./shared/footer/footer.component";
import { LivePreviewComponent } from "./preview/live-preview.component";
import { RouterOutlet } from "@angular/router";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  imports: [
    HeaderComponent,
    FooterComponent,
    LivePreviewComponent,
    RouterOutlet,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [BsModalService],
})
export class AppComponent implements AfterViewInit {
  private readonly platformId = inject(PLATFORM_ID);
  private readonly injector = inject(Injector);
  private readonly shouldShowInitModal = false;

  public async ngAfterViewInit() {
    if (isPlatformBrowser(this.platformId)) {
      const modalService = this.injector.get(BsModalService);

      const Aos = (await import("aos")).default;
      Aos.init({ once: true });
      Aos.refresh();

      setTimeout(() => {
        window.dispatchEvent(new Event("scroll"));
        window.dispatchEvent(new Event("resize"));
      }, 100);

      setTimeout(() => {
        window.dispatchEvent(new Event("scroll"));
        window.dispatchEvent(new Event("resize"));
        if (this.shouldShowInitModal) {
          modalService.show(InitModalComponent, {
            backdrop: true,
            keyboard: true,
            ignoreBackdropClick: false,
          });
        }
      }, 1000);
    }
  }
}
